/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2026-02-09 14:34:55
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import axios from 'axios';
import { host } from '../http/http'
import store from '../vuex/modules/login';
import qs from 'qs';
export namespace Public {
    /**
     * 平台端 用户登录
     */
    export var GetUsersLogin = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetUsersLogin`, body);
    };
    /**
     * 
    用户功能权限列表
     */
    export var GetTbFunctionalAuthorityByUserId = (body: any): Promise<any> => {
        return Get(`/api/TbFunctionalAuthority/GetTbFunctionalAuthorityByUserId`, body);
    };
    /**批量新增功能权限 */
    export var PostTbFunctionalAuthority = (body: any): Promise<any> => {
        return Post(`/api/TbFunctionalAuthority/PostTbFunctionalAuthority`, body);
    };
    /**
     * 
    获取用户详情
     */
    export var GetTbUserById = (body: any): Promise<any> => {
        return Get(`/api/TbUsers/GetTbUserById`, body);
    };
    /**
     * 
    获取用户列表
     */
    export var GetUserList = (body: any): Promise<any> => {
        return Get(`/api/TbUsers/GetUserList`, body);
    };
    /**新增用户 */
    export var PostAddTbUser = (body: any): Promise<any> => {
        return Post(`/api/TbUsers/PostAddTbUser`, body);
    };
    /**编辑用户状态 */
    export var PutUpdatebUserEnableStatus = (body: any): Promise<any> => {
        return Put(`/api/TbUsers/PutUpdatebUserEnableStatus`, body);
    };
    /**编辑用户 */
    export var PutUpdateUsers = (body: any): Promise<any> => {
        return Put(`/api/TbUsers/PutUpdateUsers`, body);
    };
    /**编辑密码 */
    export var PutUpdateUsersPassword = (body: any): Promise<any> => {
        return Put(`/api/TbUsers/PutUpdateUsersPassword`, body);
    };
    /**保存个人信息 */
    export var PutSavePersonInfo = (body: any): Promise<any> => {
        return Put(`/api/TbUsers/PutSavePersonInfo`, body);
    };
    /**
     * 删除用户
     */
    export var DeleteTbUser = (query: any): Promise<any> => {
        return Delete(`/api/TbUsers/DeleteTbUser?${qs.stringify(query)}`, {});
    };
    /**批量新增功能权限 */
    export var PostTbFunctionalAuthority = (body: any): Promise<any> => {
        return Post(`/api/TbFunctionalAuthority/PostTbFunctionalAuthority`, body);
    };
    /**
     * 
    用户功能权限列表
     */
    export var GetTbFunctionalAuthorityByUserId = (body: any): Promise<any> => {
        return Get(`/api/TbFunctionalAuthority/GetTbFunctionalAuthorityByUserId`, body);
    };
    /**
     * 
    销售报表/退货订单
     */
    export var GetTbSaleReportList = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTbSaleReportList`, body);
    };
    /**
     * 
    销售报表/退货订单合计
     */
    export var GetTbSaleReportTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTbSaleReportTotal`, body);
    };
    /**
     * 
    商品退回订单
     */
    export var GetReturnGoodsDetailOperate = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetReturnGoodsDetailOperate`, body);
    };
    /**
     * 
    商品退回订单合计
     */
    export var GetReturnGoodsDetailOperateTotal = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetReturnGoodsDetailOperateTotal`, body);
    };
    /**
     * 
    获取交易总览
     */
    export var GetTransactionOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTransactionOverview`, body);
    };
    /**
     * 
    获取交易总览合计
     */
    export var GetTransactionOverviewTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTransactionOverviewTotal`, body);
    };
    /**
     * 
    分类列表
     */
    export var GetAllGoodsClassList = (body: any): Promise<any> => {
        return Get(`/api/TbGoodsClass/GetAllGoodsClassList`, body);
    };
    /**
     * 查询店铺
     */
    export var GetTbShopById = (body: any): Promise<any> => {
        return Get(`/api/TbShop/GetTbShopById`, body);
    };
    /**
     * 切换店铺查询店铺列表
     */
    export var GetTbShoppListForSwitch = (body: any): Promise<any> => {
        return Get(`/api/TbShop/GetTbShoppListForSwitch`, body);
    };
    /**
     * 支付总览
     */
     export var GetPaymentOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetPaymentOverview`, body);
    };
    /**
     * 支付总览合计
     */
    export var GetPaymentOverviewTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetPaymentOverviewTotal`, body);
    };
    /**
     * 商品报表
     */
     export var GetOrderItemReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetOrderItemReportNew_V2`, body);
    };
    /**
     * 商品报表合计
     */
    export var GetOrderItemTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetOrderItemTotalV2_New`, body);
    };
    /**
     * 会员充值明细
     */
     export var GetMemberRechargeReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberRechargeReport`, body);
    };
    /**
     * 会员充值明细合计
     */
     export var GetMemberRechargeReportTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberRechargeReportTotal`, body);
    };
    /**
     * 员工月度提成
     */
     export var GetAccountReportList = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetAccountReportList`, body);
    };
    /**
     * 员工总览
     */
     export var GetEmployeeOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetEmployeeOverview`, body);
    };
    /**
     * 员工总览合计
     */
     export var GetEmployeeOverviewTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetEmployeeOverviewTotal`, body);
    };
    /**
     * 报表导出-销售、退货订单
     */
    export var TbSaleReportExport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReportExport/TbSaleReportExport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-商品销售报表导出
     */
    export var OrderItemReportExport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReportExport/OrderItemReportExportNew_V2", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-交易总览报表导出
     */
    export var TransactionOverviewExport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReportExport/TransactionOverviewExport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-商品退回报表导出
     */
    export var ReturnGoodsExport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReportExport/ReturnGoodsExport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-门店支付报表导出
     */
     export var GetPaymentOverviewReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetPaymentOverviewReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-
     */
     export var GetGoodsItemsOverviewReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetGoodsItemsOverviewReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-
     */
     export var GetMemberTradeOverviewReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetMemberTradeOverviewReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-员工报表
     */
     export var GetAccountOverviewReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetAccountOverviewReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 报表导出-员工总览报表导出
     */
     export var GetEmployeeOverviewReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetEmployeeOverviewReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 库存查询列表
     */
     export var GetGoodsItemsList = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsItemsList`, body);
    };
    /**
     * 库存查询列表_合计
     */
    export var GetGoodsItemsListForTotal = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsItemsListForTotal`, body);
    };
    /**
     * 报表导出-销售、退货订单
     */
     export var GetTbSaleReportListReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReport/GetTbSaleReportListReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 获取订单详情
     */
    export var GetOrderById = (id: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderById?id=${id}`, {});
    };
    /**
     * 查询商品列表
     */
    export var GetTbGoodsList = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsList`, body);
    };
    /**
     * 查询商品列表合计
     */
    export var GetTbGoodsTotal = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsTotal`, body);
    };
    /**
     * 销售报表合计(官网web)
     */
    export var GetTbSaleReportTotalForWeb = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTbSaleReportTotalForWebV2`, body);
    };
    /**
     * 查询商品
     */
    export var GetTbGoodsById = (id: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsById?id=${id}`, {});
    };
    /**
     * 获取商品导入Excel模版
     */
    export var DownloadGoodsImportExcel = (): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/ExInport/DownloadGoodsImportExcel", {
            params: {},
            responseType: "blob"
        });
    };
    /**
     * 获取员工交接班报表列表(官网web)
     */
    export var GetTbHandoverList = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetTbHandoverList`, body);
    };
    /**
     * 获取员工交接班报表列表-统计(官网web)
     */
    export var GetHandoverTotal = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetHandoverTotal`, body);
    };
    /**
     * 报表导出-员工交接班报表
     */
     export var TbHandoverExport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbReportExport/TbHandoverExport", {
            params: body,
            responseType: "blob"
        });
    };
    /**获取是否开通网店 */
    export var GetOnlineIsOpen = (): Promise<any> => {
        return Get(`/api/TbShop/GetOnlineIsOpen`, {});
    };
    /**
     * 获取线上订单列表
     */
    export var GetOnlineOrderListToPos = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderListToPos`, body);
    };
    /**
     * 获取网店订单商品详情
     */
    export var GetOnlineOrderById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderById`, body);
    };
     /**
     * 导出网店订单列表
     */
    export var GetOnlineOrderListToPosReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbOrder/GetOnlineOrderListToPosReport", {
            params: body,
            responseType: "blob"
        });
    }
     /**
     * 导出网店订单明细
     */
    export var GetOnlineOrderItemListToPosReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbOrder/GetOnlineOrderItemListToPosReport", {
            params: body,
            responseType: "blob"
        });
    }
     /**
     * 导出网店订单详情的明细
     */
    export var GetOnlineOrderItemListToPosByIdReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbOrder/GetOnlineOrderItemListToPosByIdReport", {
            params: body,
            responseType: "blob"
        });
    }
     /**
     * 导出线上订单商品销量列表
     */
    export var GetOnlineOrderGoodsListToPosReport = (body: any): Promise<any> => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.jwtToken;
        return axios.get(host() + "api/TbOrder/GetOnlineOrderGoodsListToPosReport", {
            params: body,
            responseType: "blob"
        });
    }
    /**
     * 获取线上订单商品销量列表
     */
    export var GetOnlineOrderGoodsListToPos = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOnlineOrderGoodsListToPos`, body);
    };
    /**
     * 
    网店端的分类列表
     */
    export var GetTbGoodsClassByNameToPos = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetTbGoodsClassByNameToPos`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_Public.ts